import { connect } from 'react-redux';
import { Api } from '../../../typings/api';
import { StoreState } from '../../../reducers';
import DriveItemDownloadButton, { DownloadAllButtonStatus } from '../../../components/DriveItem/DownloadButton';
import DownloadManagerUtils from '../../../utils/downloadManager';
import { DownloadAllStatus } from '../../DownloadManager/reducer';

interface DownloadButtonContainerProps {
	driveItems?: Api.DriveItem[];
}

const mapStateToProps = (state: StoreState, props: DownloadButtonContainerProps) => {
	const { galleryInfos, downloadManager, driveList } = state;
	const { downloadAllStatus, isDownloadingAll, isDeletingAll } = downloadManager;
	const hasItemsToDownload = DownloadManagerUtils.hasItemsToDownload(downloadManager, driveList, galleryInfos);
	const { driveItems } = props;
	const galleryId = galleryInfos.config.applicationGallery;
	const isDownloading = driveItems ? DownloadManagerUtils.isItemDownloading(downloadManager, driveItems[0].id) : false;
	const driveItemId = driveItems ? driveItems[0].id : galleryInfos.config.applicationGallery;
	const loaderStep = driveItems
		? DownloadManagerUtils.getItemLoaderStep(downloadManager, driveItemId)
		: DownloadManagerUtils.getGalleryLoaderStep(downloadManager, driveList, galleryId, isDownloadingAll);
	const downloadAllButtonStatus = getDownloadAllButtonStatus(downloadAllStatus, hasItemsToDownload);

	return { galleryInfos, isDownloading, isDeletingAll, loaderStep, isDownloadingAll, downloadAllButtonStatus };
};


const getDownloadAllButtonStatus = (downloadAllStatus: DownloadAllStatus, hasItemsToDownload: boolean): DownloadAllButtonStatus => {
	switch (downloadAllStatus) {
		case DownloadAllStatus.NotStarted:
			return DownloadAllButtonStatus.DownloadAll;
		case DownloadAllStatus.Started:
			return DownloadAllButtonStatus.ContinueDownloading;
		case DownloadAllStatus.Finished:
			return hasItemsToDownload ? DownloadAllButtonStatus.Update : DownloadAllButtonStatus.DownloadComplete;
	}
};
export default connect(mapStateToProps)(DriveItemDownloadButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItem/DownloadButton/index.tsx